import React from 'react';
import { motion } from 'framer-motion';
import { X, Lightbulb } from 'lucide-react';
export function PainSection() {
  return <section className="w-full bg-white py-16 px-4 border-t border-gray-200" data-id="element-157">
      <div className="max-w-3xl mx-auto" data-id="element-158">
        <div className="text-center mb-10" data-id="element-159">
          <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-160">
            ¿Te suena familiar?
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mt-6 leading-tight" data-id="element-161">
            Si Querés Resolver una Avería en Casa, Déjame Hacerte una Pregunta
            Honesta
          </h2>
        </div>

        <div className="prose prose-lg max-w-none text-gray-700 font-medium space-y-6 mb-10" data-id="element-162">
          <p data-id="element-163">
            ¿Cuánto te cobró el último electricista que llamaste? ¿60€? ¿80€?
            ¿Más? Y estuvo exactamente 15 minutos en tu casa.
          </p>
          <p data-id="element-164">
            Cambiar un enchufe. Instalar una lámpara. Poner un interruptor
            nuevo. Son trabajos que cualquier persona puede hacer. El problema
            no es que seas torpe. El problema es que nadie te enseñó cómo
            hacerlo.
          </p>
          <p data-id="element-165">
            Y mientras tanto, cada pequeña avería que aparece en tu casa le
            regala dinero a alguien que sabe lo que vos no sabés.
          </p>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 md:p-8 mb-10 shadow-sm" data-id="element-166">
          <ul className="space-y-4" data-id="element-167">
            {['Cada avería pequeña te cuesta entre 60€ y 120€ en mano de obra', 'Esperás días para que el electricista tenga hueco en su agenda', 'No sabés si te están cobrando de más porque no entendés nada', 'Tenés miedo de tocar algo y cargarte toda la instalación', 'Los vídeos de YouTube son confusos, incompletos o no son para tu modelo', 'Te sentís dependiente de otra persona para algo que pasa en tu propia casa'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-168">
                <X className="text-red-600 shrink-0 mt-1" size={24} strokeWidth={3} data-id="element-169" />
                <span className="text-gray-800 font-semibold text-lg" data-id="element-170">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-blue-50 border-2 border-blue-200 rounded-xl p-6 flex flex-col md:flex-row items-center gap-6 shadow-md" data-id="element-171">
          <div className="bg-blue-100 p-4 rounded-full shrink-0" data-id="element-172">
            <Lightbulb className="text-blue-600" size={40} data-id="element-173" />
          </div>
          <p className="text-blue-900 font-bold text-lg md:text-xl leading-snug" data-id="element-174">
            <span className="text-blue-700 uppercase tracking-wide text-sm block mb-1" data-id="element-175">
              Dato real:
            </span>
            Una familia media española gasta entre 400€ y 800€ al año en
            reparaciones eléctricas domésticas que podría resolver ella misma en
            menos de 30 minutos con el conocimiento correcto.
          </p>
        </motion.div>
      </div>
    </section>;
}